import React, {useState} from 'react'
import {Flex} from '/app/src/component';


//Cause I am really tired of mixing BASIC CSS with my domain view states.
const withHover = (WrappedComponent) => {
    return (props) => {
        const [hovered, setHovered] = useState(false)
        return (
            <Flex
                onMouseEnter={ () => setHovered(true) }
                onMouseLeave={ () => setHovered(false) }
                cursor="pointer">
                <WrappedComponent
                    isHovered={hovered}
                    {...props}/>
            </Flex>
        )
    }
}

export default withHover



// WEBPACK FOOTER //
// ./src/hoc/withHover.js